export const deepClone = (obj: any) => JSON.parse(JSON.stringify(obj));
